import React from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { HiChevronRight } from 'react-icons/hi2';
import { useAppDispatch } from '../../../redux/hooks';
import { openAuth } from '../../../redux/slice/authModalSlice';
import { getAuthToken } from '../../../helper/helper';
import { Images } from '../../../utils/imageConstants';
import './CreateLeagueBanner.scss';
import { GoTrophy } from "react-icons/go";

const CreateLeagueBanner: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const token = getAuthToken();

  const handleCreateLeague = () => {
    if (!token) {
      toast.error('Please login or signup to create a league.');
      dispatch(openAuth('signin'));
      return;
    }
    navigate('/create-league');
  };

  return (
    <section className="logged-home-create-league-banner">
      <div className="logged-home-create-league-inner">
        <div className="logged-home-create-league-content">
          <div className="logged-home-create-league-badge">
            <GoTrophy className="badge-icon" aria-hidden />
            Be An Organizer
          </div>
          <div className="logged-home-create-league-content-title-desc">
            <h2 className="logged-home-create-league-title">Start Your Own Cricket League</h2>
            <p className="logged-home-create-league-desc">
              Organize Your Own Cricket League With Scheduling, Scoring, And Team Management Tools- All In One Place
            </p>
          </div>
          <button
            type="button"
            className="logged-home-create-league-btn"
            onClick={handleCreateLeague}
          >
            Create League
            <HiChevronRight className="btn-chevron" aria-hidden />
          </button>
        </div>
        <div className="logged-home-create-league-image">
          <img
            src={Images.bowl_image}
            alt="Cricket ball on field"
            className="logged-home-create-league-image-img"
          />
        </div>
      </div>
    </section>
  );
};

export default CreateLeagueBanner;
